import { ApiService } from 'services';
import { handleException } from 'actions/exceptions';

import { hideAddWhdFormModal } from './addWhdFormModal';
import { getWhdForms } from './getWhdResults';

export const ADD_WHD_FORM_REQUEST = 'ADD_WHD_FORM_REQUEST';
export const ADD_WHD_FORM_SUCCESS = 'ADD_WHD_FORM_SUCCESS';
export const ADD_WHD_FORM_FAILURE = 'ADD_WHD_FORM_FAILURE';
export const RESET_ADDING_WHD_FORM = 'RESET_ADDING_WHD_FORM';

function requestAddWhdForm() {
  return {
    type: ADD_WHD_FORM_REQUEST,
    isAddingWhdForm: true
  };
}

function rejectAddWhdForm(addingWhdFormError) {
  return {
    type: ADD_WHD_FORM_FAILURE,
    isAddingWhdForm: false,
    addingWhdFormError
  };
}

function resetAddWhdForm() {
  return {
    type: RESET_ADDING_WHD_FORM,
    addingWhdFormError: null
  };
}

export function addWhdForm(data) {
  const formData = new FormData();

  if (data.accountNo) {
    formData.append('accountNo', data.accountNo);
  }
  if (data.paymentType) {
    formData.append('paymentType', data.paymentType);
  }
  if (data.dateOfPayment) {
    formData.append('dateOfPayment', data.dateOfPayment);
  }
  if (data.paymentAmount) {
    formData.append('paymentAmount', data.paymentAmount);
  }
  return (dispatch) => {
    dispatch(requestAddWhdForm());

    const promise = () => ApiService
      .addWhdForm(data.formType, formData)
      .then((response) => {
        dispatch(hideAddWhdFormModal());
        dispatch(getWhdForms(data.accountNo));
      })
      .catch((error) => {
        if (!error.response && error.retries && error.retries > 1) {
          ApiService.addQueuedPromise(promise, error);
        }
        if (error.response || (error.retries && error.retries > 1)) {
          dispatch(handleException(error, rejectAddWhdForm));
        }
      });
    return promise();
  };
}

export function hideAddWhdFormError() {
  return dispatch => dispatch(resetAddWhdForm());
}
